import React from "react";
import Layout from "../../NewComponent/Layout/Layout";
import SearchBar from "../../NewComponent/SearchBar/SearchBar";
import KeyTermBox from "./KeyTermBox";
import { Spin } from "antd";
import { getKeyTermData } from "../../API/api";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";
import KeyTagDataBox from "./KeyTagDataBox";

export default function NewKeyTermPage() {
  const termState = useSelector((state) => state.keyTerm);
  const tagState = useSelector(state=>state.keyTag);
  const dispatch = useDispatch();
  const {
    keyTermDomainUpdate,
    keyTermSearchQueryUpdate,
    keyTermDataIsLoading,
    keyTermDataUpdate,
    keyTermDataPageNoUpdate,
    getkeyTagPayload,
    keyTermWordsChange,
    answerUuidSentToUpdateViewCount,
    allAnswerUuidEmptyForScrollCount,
  } = bindActionCreators(Actions, dispatch);
  const fetchKeyTerms = () => {
    if(tagState.isBack){
      return
    }
    keyTermDataIsLoading(true);
    getKeyTermData(
      termState.pageNo,
      termState.domains === "All" ? "" : termState.domains,
      termState.searchQuery,
      termState.words
    ).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        // console.log(res.data.data);
        if (res.data.data === undefined) {
          keyTermDataUpdate({ data: [], count: 0 });
          return;
        } else {
          keyTermDataUpdate({
            data: res.data.data.tagsData,
            count: res.data.data.totalCount,
          });
        }
      }
    });
  };
  React.useEffect(() => {
    fetchKeyTerms();
  }, [
    termState.pageNo,
    termState.domains,
    termState.searchQuery,
    termState.words,
  ]);
  return (
    <Layout>
      <div
        style={{
          width: "74%",
          margin: "auto",
          marginTop: "1%",
          marginBottom: "7%",
        }}
      >
        {!tagState.isBack &&<div className="mb-5">
          <SearchBar />
        </div>}
        {/* <Spin spinning={true}> */}
        {!tagState.isBack && <KeyTermBox />}
        {tagState.isBack && <KeyTagDataBox />}

        {/* </Spin> */}
      </div>
    </Layout>
  );
}
